import {
    JOURNAL_REQUEST,
    JOURNAL_SUCCESS,
    JOURNAL_ERROR,
    JOURNAL_SET_FILTER,
    JOURNAL_MORE_SUCCESS,
    JOURNAL_TAB_CHANGE,
    JOURNAL_TABS,
    JOURNAL_RESET_STATE,
} from 'state/actions/journal'

import { groupResourceJournalByDay } from 'helpers/journal'

const initialState = {
    loading: false,
    loaded: false,
    errorMessage: null,
    records: {
        data: [],
        meta: {},
    },
    filter: {
        resourceType: 'all',
        reserveType: 'clan_journal_reserves.all',
        battle_type: undefined,
        max_vehicle_level: undefined,
        actions: undefined,
        reserve_types: undefined,
        limit: 32,
    },
    selectedTab: JOURNAL_TABS.battles,
}

export default function reducer(state = initialState, action = {}) {
    switch (action.type) {
    case JOURNAL_REQUEST: {
        return {
            ...state,
            loading: true,
            loaded: false,
            errorMessage: null,
        }
    }
    case JOURNAL_SUCCESS: {
        return {
            ...state,
            loading: false,
            loaded: true,
            records: groupResourceJournalByDay(action.payload.records),
        }
    }
    case JOURNAL_ERROR: {
        return {
            ...state,
            loading: false,
            loaded: false,
            errorMessage: action.payload.errorMessage,
        }
    }
    case JOURNAL_SET_FILTER: {
        return {
            ...state,
            filter: {
                ...state.filter,
                ...action.payload.filter,
            },
        }
    }
    case JOURNAL_MORE_SUCCESS: {
        action.payload.records.data = state.records.data.concat(action.payload.records.data)
        return {
            ...state,
            records: groupResourceJournalByDay(action.payload.records),
        }
    }
    case JOURNAL_TAB_CHANGE: {
        return {
            ...state,
            selectedTab: action.payload.selectedTab,
        }
    }
    case JOURNAL_RESET_STATE: {
        return {
            ...state,
            ...initialState,
        }
    }
    default:
        return state
    }
}



// WEBPACK FOOTER //
// ./state/reducers/journal.js